import { Tooltip } from "@mui/material";
import Flex from "./Flex";
import { HTMLAttributes } from "react";
import { cn } from "./lib/utils";

export interface DocumentNameProps extends HTMLAttributes<HTMLAnchorElement> {
  name: string;
  onClick?: () => void;
  altName?: string;
}

const DocumentName = (props: DocumentNameProps) => {
  const { name, onClick, altName, children, className, ...rest } = props;

  return (
    <Flex>
      <Tooltip arrow title={`Open '${name}'`}>
        <a
          className={cn("text-peri-900 text-xs overflow-hidden truncate max-w-64", className)}
          onClick={onClick}
          {...rest}>
          {altName ? altName : name}
          {children}
        </a>
      </Tooltip>
    </Flex>
  );
};

export default DocumentName;
